module.exports = "<div class=\"an_404\">\n    <div class=\"an_404m\">\n        <div class=\"h2\">如你所看到的  这个页面被不明“怪物”吃了...</div>\n        <div class=\"en\">error...Sorry, you can visit the page was blown away -</div>\n        <div class=\"button\">\n            <button nz-button href=\"domains\" routerLink=\"/app/index\"><i class=\"anticon anticon-left\"></i>返回首页</button>\n            <button nz-button ui-sref=\"profitManage\" onClick=\"document.location.reload()\"><i class=\"anticon anticon-reload\"></i>刷新试试</button>\n        </div>\n    </div>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/no-content/no-content.component.html
// module id = 1036
// module chunks = 75